module.exports = "title,letter,uuid\nWomen,W,58fd7e80-0aa8-4bd9-95b6-93f56a143d87\nMen,M,85d01cb8-9215-4767-880d-97b1c58737fd\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/data/genders.csv
// module id = 1515
// module chunks = 0